import { CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { PageHeader, Card, Space, List, Modal, Button, Table, Dropdown, Menu, Form, Input } from "antd"
import { useEffect, useState } from "react";
import { Link } from "react-router-dom"
import { getShortLink, getShortLinks, saveNewShortLink, updateShortLink } from "../../appRedux/actions/ShortLink";
import PageContentWrapper from "../../components/PageContentWrapper";
import { useHistory, useParams } from "react-router-dom";

export default function NewShortlinkage() {
  const [loading, setLoading] = useState(true);
  const [form] = Form.useForm();
  const history = useHistory();
  const { shortlinkId } = useParams();

  useEffect(() => {
    if (!shortlinkId)
      return
    getShortLink(shortlinkId).then(response => {
      form.setFieldsValue(response);
      setLoading(false);
    });
  }, []);

  function onSubmit(values) {
    if (shortlinkId)
      updateShortLink(values, shortlinkId).then(() => history.push("/shortlinks"))
    else
      saveNewShortLink(values).then(() => history.push("/shortlinks"))
  }

  return <>
    <PageContentWrapper
      title={(shortlinkId ? "Edit" : "Tambah") + " Short Link"}
      backLink={"/shortlinks"}
    >
      <Form
        form={form}
        layout="vertical"
        loading={loading}
        style={{ padding: 10 }}
        onFinish={(values) => {
          onSubmit({ ...values });
        }}
      >
        <Form.Item
          label="Nama"
          name="name"
          rules={[{ required: true, message: "Mohon isikan nama" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="URL"
          name="url"
          rules={[
            { required: true, message: "Mohon isikan url" },
            {
              pattern: /^(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s\/]{2,}(?:\/[^\s]*)?|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s\/]{2,}(?:\/[^\s]*)?)$/,
              message: "Format URL tidak valid."
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Kode"
          name="code"
          rules={[
            {
              pattern: /^[a-zA-Z0-9_-]*$/,
              message: "Hanya boleh berisi huruf, angka, underscore, dan strip."
            },
          ]}
          extra="Kosongkan jika ingin auto generate"
        >
          <Input placeholder="Kosongkan jika ingin auto generate" />
        </Form.Item>
        <Form.Item>
          <center>
            <Button type="primary" htmlType="submit">
              Simpan
            </Button>
          </center>
        </Form.Item>
      </Form>
    </PageContentWrapper>
  </>
}
